import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

export function PassportSymbolOutlined({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("PassportSymbolOutlined");
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 48 48"
      testId={testId}
      sx={mergeSx({ w: "100px" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

PassportSymbolOutlined.displayName = "PassportSymbolOutlined";
